import React from 'react';
import styled from 'styled-components';

const NotFound = (props) => {
    return (
        <Body>
            <Title>Not Found</Title>
            <Contents>
                ページが存在しません。<br/>
                URLが正しいか確認してください。
            </Contents>
        </Body>
    );
}

export { NotFound };

const Body = styled.div`
    padding: 0 20px;
`;
const Title = styled.h1`
    font-size: 24px;
    font-weight: bold;
`;
const Contents = styled.div`
`;
